/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.convo.leaveConvo'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  convoId: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  rev: /*#__PURE__*/ l.string(),
  convoId: /*#__PURE__*/ l.string(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Leaves a conversation (direct or group). For group, this effectively removes membership. For direct, membership is never removed, only changed to remove from enumerations by the user who left. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'OwnerCannotLeave',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
